import React from "react";
import { useTranslation } from "../../i18n";

const AuthFooter = ({ consentText }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mt-9 flex items-center justify-center gap-8 text-[12px] font-medium uppercase tracking-[0.16em] text-[#6b7280]">
        <div className="flex items-center gap-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 3L19 6V11C19 15.4183 16.134 19.2167 12 20.5C7.866 19.2167 5 15.4183 5 11V6L12 3Z"
              fill="#6b7280"
            />
            <path
              d="M9.5 12L11.2 13.7L14.8 10.1"
              stroke="white"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>{t("authUi.gdprCompliant")}</span>
        </div>

        <div className="flex items-center gap-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 10V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10"
              stroke="#6b7280"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <rect x="5" y="10" width="14" height="11" rx="2" fill="#6b7280" />
          </svg>
          <span>{t("authUi.sslSecure")}</span>
        </div>
      </div>

      {/* Terms/Privacy are shown as plain text until the real pages exist,
          so the footer doesn't offer links that go nowhere. */}
      <p className="mt-8 text-center text-[12px] leading-6 text-[#4b5563]">
        {consentText}{" "}
        <span className="font-medium">{t("authUi.termsOfService")}</span>{" "}
        {t("authUi.consentBetween")}{" "}
        <span className="font-medium">{t("authUi.privacyPolicy")}</span>{" "}
        {t("authUi.consentSuffix")}
      </p>
    </>
  );
};

export default AuthFooter;
